window.Suggestion = {

    overlay     : document.querySelector("[data-js='suggest']"), // The suggest overlay
    buttonOpen  : document.querySelector("[data-js='suggest-open']"), // Suggest open button
    buttonClose : document.querySelector("[data-js='suggest-close']"), // Suggest close button

    // Let's launch this thing
    liftoff : () => {
        Suggestion.showHideOverlay()
    },

    // Show/Hide Overlay
    showHideOverlay : () => {
        
        Suggestion.overlay.addEventListener('click' , (event) => {
            if (event.target == Suggestion.overlay) {
                Suggestion.overlay.close();
            } 
        });

        // "Show the dialog" button opens the dialog modally
        Suggestion.buttonOpen.addEventListener("click", () => {
            Suggestion.overlay.showModal();
        });

        // "Close" button closes the dialog
        Suggestion.buttonClose.addEventListener("click", (event) => {
            event.preventDefault();
            Suggestion.overlay.close();
        });

    }

};

Suggestion.liftoff()